import React, { useState } from "react";
import {
    Input,
    FormControl,
    FormLabel,
    Flex,
    Collapse,
    NumberInput,
    NumberInputField,
    NumberInputStepper,
    NumberIncrementStepper,
    NumberDecrementStepper,
    InputGroup,
    InputLeftAddon,
    Text,
    Checkbox,
} from "@chakra-ui/react";
import { LuChevronUp, LuChevronDown } from "react-icons/lu";



const ImageBlockEditor = ({ block, onChange }) => {
    const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
    const [addvideoLink, setAddVideoLink] = useState(false);

    const handleImageLinkChange = (e) => {
        onChange({ ...block, props: { ...block.props, imageUploadUrlLink: e.target.value } });
    };

    const handleMarginChange = (margin, value) => {
        onChange({ ...block, props: { ...block.props, [margin]: value } });
    };
    const handleCheckChange = (event) => {
        setAddVideoLink(event.target.checked)
    };

    return (
        <div>
            <Input
                mt={3}
                style={{ backgroundColor: "white" }}
                value={block.props.imageUploadUrl}
                placeholder="Enter Image Upload Url"
                onChange={(e) => onChange({ ...block, props: { ...block.props, imageUploadUrl: e.target.value } })}
            />

            <Flex mt={4} gap={2} flexWrap="wrap">
                <Checkbox defaultChecked={addvideoLink} onChange={handleCheckChange}>Add Link to Image</Checkbox>
                {addvideoLink && (
                    <FormControl >
                        <FormLabel fontSize="xs" mb={1}>Link</FormLabel>
                        {/* <Flex> */}
                        <Input
                            type="videolink"
                            value={block.props.imageUploadUrlLink}
                            onChange={handleImageLinkChange}
                            width="100%"
                            style={{ border: "1px solid #CCCCCC", borderRadius: "5px", backgroundColor: "white" }}
                        />

                        {/* </Flex> */}
                    </FormControl>
                )}



            </Flex>

            <Text
                mt={3}
                size="xs"
                color="blue.500"
                cursor={"pointer"}
                onClick={() => setShowAdvancedOptions(!showAdvancedOptions)}
                width="full"
                style={{ display: "flex", alignItems: "center" }}
            >
                {showAdvancedOptions ? <LuChevronUp /> : <LuChevronDown />}<span style={{ marginLeft: "3px" }}>{showAdvancedOptions ? "Hide" : "Show"} Advanced Options</span>
            </Text>

            <Collapse in={showAdvancedOptions} animateOpacity>
                <Flex mt={4} gap={2} wrap="wrap">
                    <FormControl maxW="120px">
                        <FormLabel fontSize="xs" mb={1}>Margin Top</FormLabel>
                        <InputGroup size="sm" style={{ border: "1px solid #CCCCCC", borderRadius: "5px", backgroundColor: "white", paddingRight: "5px" }}>
                            <NumberInput
                                value={block.props.marginTop}
                                min={0}
                                max={100}
                                onChange={(value) => handleMarginChange('marginTop', value)}
                                style={{ border: "none !important" }}
                            >
                                <NumberInputField />
                                {/* <NumberInputStepper>
                                    <NumberIncrementStepper />
                                    <NumberDecrementStepper />
                                </NumberInputStepper> */}
                            </NumberInput>
                             <InputLeftAddon children="px" style={{ border: "none", borderRadius: "5px", backgroundColor: "white" }} />
                        </InputGroup>
                    </FormControl>

                    <FormControl maxW="120px">
                        <FormLabel fontSize="xs" mb={1}>Margin Right</FormLabel>
                          <InputGroup size="sm" style={{ border: "1px solid #CCCCCC", borderRadius: "5px", backgroundColor: "white", paddingRight: "5px" }}>
                            <NumberInput
                                value={block.props.marginRight}
                                min={0}
                                style={{ border: "none !important" }}
                                max={100}
                                onChange={(value) => handleMarginChange('marginRight', value)}
                            >
                                <NumberInputField />
                                {/* <NumberInputStepper>
                                    <NumberIncrementStepper />
                                    <NumberDecrementStepper />
                                </NumberInputStepper> */}
                            </NumberInput>
                             <InputLeftAddon children="px" style={{ border: "none", borderRadius: "5px", backgroundColor: "white" }} />
                        </InputGroup>
                    </FormControl>

                    <FormControl maxW="120px">
                        <FormLabel fontSize="xs" mb={1}>Margin Bottom</FormLabel>
                          <InputGroup size="sm" style={{ border: "1px solid #CCCCCC", borderRadius: "5px", backgroundColor: "white", paddingRight: "5px" }}>
                            <NumberInput
                                value={block.props.marginBottom}
                                min={0}
                                style={{ border: "none !important" }}
                                max={100}
                                onChange={(value) => handleMarginChange('marginBottom', value)}
                            >
                                <NumberInputField />
                                {/* <NumberInputStepper>
                                    <NumberIncrementStepper />
                                    <NumberDecrementStepper />
                                </NumberInputStepper> */}
                            </NumberInput>
                             <InputLeftAddon children="px" style={{ border: "none", borderRadius: "5px", backgroundColor: "white" }} />
                        </InputGroup>
                    </FormControl>

                    <FormControl maxW="120px">
                        <FormLabel fontSize="xs" mb={1}>Margin Left</FormLabel>
                          <InputGroup size="sm" style={{ border: "1px solid #CCCCCC", borderRadius: "5px", backgroundColor: "white", paddingRight: "5px" }}>
                            <NumberInput
                                value={block.props.marginLeft}
                                min={0}
                                max={100}
                                style={{ border: "none !important" }}
                                onChange={(value) => handleMarginChange('marginLeft', value)}
                            >
                                <NumberInputField />
                                {/* <NumberInputStepper>
                                    <NumberIncrementStepper />
                                    <NumberDecrementStepper />
                                </NumberInputStepper> */}
                            </NumberInput>
                             <InputLeftAddon children="px" style={{ border: "none", borderRadius: "5px", backgroundColor: "white" }} />
                        </InputGroup>
                    </FormControl>
                </Flex>
            </Collapse>
        </div>
    );
};

export default ImageBlockEditor;